import React, { FC } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { useFragment } from 'react-relay';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Segments from 'components/FlightShortDetailsSegments';

import { FlightShortDetails_flight$key } from '__generated__/FlightShortDetails_flight.graphql';

type Props = {
  flight: FlightShortDetails_flight$key;
  showTime?: boolean;
  linkTo?: string;
  noLink?: boolean;
};

const FlightShortDetails: FC<Props> = props => {
  const { flight, linkTo, showTime = true, noLink = false } = props;

  const { id, forwardSegments, returnSegments } = useFragment(
    graphql`
      fragment FlightShortDetails_flight on FlightType {
        id

        forwardSegments {
          ...FlightShortDetailsSegments_segments
        }

        returnSegments {
          ...FlightShortDetailsSegments_segments
        }
      }
    `,
    flight
  );

  const href = linkTo || `/flights/${id}`;

  return noLink ? (
    <Box sx={{ fontSize: '0.8em' }}>
      <Segments showTime={showTime} segments={forwardSegments} />
      <Segments showTime={showTime} segments={returnSegments} />
    </Box>
  ) : (
    <Link href={href} sx={{ fontSize: '0.8em' }} underline="none">
      <Segments showTime={showTime} segments={forwardSegments} />
      <Segments showTime={showTime} segments={returnSegments} />
    </Link>
  );
};

export default FlightShortDetails;
